import { render, staticRenderFns } from "./wy-interactions-compare-metrics-cal-b.vue?vue&type=template&id=f77c49a4&"
import script from "./wy-interactions-compare-metrics-cal-b.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-compare-metrics-cal-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports